import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesSecuritySchemesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-security-schemes-edit',
	path: '/secure/admin/EditIssueSecurityScheme([!%]?[\\w]*).jspa',
};
